const Lottie = dynamic(() => import('react-lottie'), { ssr: false })
import dynamic from 'next/dynamic'
import { type ReactNode, useEffect, useState } from 'react'
import loading from './loading.json'
interface LoadingIndicatorProps {
  text?: string | ReactNode
}
export const LoadingIndicator = ({ text }: LoadingIndicatorProps) => {
  const [isClient, setIsClient] = useState(false)

  useEffect(() => {
    setIsClient(true)
  }, [])
  if (!isClient) {
    return null
  }
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: loading,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  }
  return (
    <>
      <div className='fixed left-0 top-0 z-[99999] h-[100vh] w-full bg-black-400/50'>
        <div className='absolute left-[50%] top-[50%] h-[80px] w-[180px] translate-x-[-50%] translate-y-[-50%]'>
          <Lottie options={defaultOptions} height={80} width={80} />

          {typeof text === 'string' ? (
            <p className='text-center text-white'>{text}</p>
          ) : (
            text
          )}
        </div>
      </div>
    </>
  )
}
